import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    agreement: graphql(`
        fragment isAgreementDumbMeter_Agreement on AgreementType {
            __typename
            supplyPoint {
                meterPoint {
                    isSmartMeter
                }
            }
        }
    `),
}

type IsAgreementDumbMeterProps = {
    agreement: FragmentOf<typeof graphQLFragments.agreement>
}

export function isAgreementDumbMeter(props: IsAgreementDumbMeterProps) {
    const agreement = readFragment(graphQLFragments.agreement, props.agreement)

    return !agreement.supplyPoint?.meterPoint?.isSmartMeter
}

isAgreementDumbMeter.fragments = graphQLFragments
